// Generated by CoffeeScript 2.4.1
(function() {
  var GET, POST, Weaver, WeaverMetaQueries, _, graphSelection, luxon, moment,
    indexOf = [].indexOf;

  Weaver = require('./Weaver');

  GET = Weaver.GET;

  POST = Weaver.POST;

  moment = require('moment');

  luxon = require('luxon');

  _ = require('lodash');

  graphSelection = async function(parameters) {
    var g, list, map, ref;
    map = function(graph) {
      if (graph === void 0 || graph === null) {
        return 'FROM DEFAULT';
      } else {
        return `FROM <${graph}>`;
      }
    };
    list = [];
    if (_.has(parameters, 'graph')) {
      if (ref = parameters.graph, indexOf.call(Weaver.Query.hiddenGraphs, ref) >= 0) {
        throw new Error(`The specified graph ${parameters.graph} is in the list of hiddenGraphs`);
      }
      list = [parameters.graph];
    } else {
      list = (await (async function() {
        var j, len, ref1, ref2, results1;
        ref1 = (await Weaver.Graph.list());
        results1 = [];
        for (j = 0, len = ref1.length; j < len; j++) {
          g = ref1[j];
          if (ref2 = g.id(), indexOf.call(Weaver.Query.hiddenGraphs, ref2) < 0) {
            results1.push(g.id());
          }
        }
        return results1;
      })());
    }
    return ((function() {
      var j, len, results1;
      results1 = [];
      for (j = 0, len = list.length; j < len; j++) {
        g = list[j];
        results1.push(map(g));
      }
      return results1;
    })()).join('\n');
  };

  WeaverMetaQueries = class WeaverMetaQueries {
    static _applyPreferredLabel(item, attributeKeys) {
      var j, key, len;
      item.label = void 0; // default value
      for (j = 0, len = attributeKeys.length; j < len; j++) {
        key = attributeKeys[j];
        if (item.labels[key] != null) {
          item.label = item.labels[key];
          break;
        }
      }
      return item;
    }

    static _transformDatesToMomentObjects(results) {
      var d, j, k, keys, l, len, len1, obj, value;
      keys = ['value', 'label', 'min', 'max'];
      for (j = 0, len = results.length; j < len; j++) {
        obj = results[j];
        for (l = 0, len1 = keys.length; l < len1; l++) {
          k = keys[l];
          value = obj[k];
          if ((value != null) && isNaN(Number(value))) {
            if (Weaver.timeLibrary === 'native') {
              d = new Date(value);
              if (!isNaN(value)) {
                obj[k] = d;
              }
            } else if (Weaver.timeLibrary === 'moment') {
              d = moment(value, moment.ISO_8601, true);
              if (d.isValid()) {
                obj[k] = d;
              }
            } else if (Weaver.timeLibrary === 'luxon') {
              d = luxon.DateTime.fromISO(value);
              if (d.isValid) {
                obj[k] = d;
              }
            } else {
              throw new Error('Unsupported time library configured');
            }
          }
        }
      }
      return results;
    }

    static async _get(metaquery, parameters, target) {
      var string;
      // The parse argument tells weaver-server to not interpret the result, it's
      // a hack similar to the ones used for querying, and can be avoided once we
      // get rid of sockets.
      string = (await POST('v2.projects', {
        method: "GET",
        path: `/meta/queries/${metaquery}`,
        parameters,
        parse: false
      }, target));
      return WeaverMetaQueries._transformDatesToMomentObjects(_.isObject(string) ? string : JSON.parse(string));
    }

    // parameters:
    //   graph
    //   limit
    //   offset
    static async typesAndCount(attributeKeys, memberKey, parameters = {}) {
      var clazz, clazzGraph, count, i, item, items, j, key, label, limit, offset, ref, ref1, ref2, res, results1;
      if (attributeKeys.length < 1) {
        throw new Error('Please specify at least one item in attributeKeys');
      }
      limit = parameters.limit != null ? `LIMIT ${parameters.limit}` : "";
      offset = parameters.offset != null ? `OFFSET ${parameters.offset}` : "";
      res = (await new Weaver.Sparql(`SELECT DISTINCT ?clazz ?count ?key ?label\n${(await graphSelection(parameters))}\nWHERE {\n  {\n    SELECT ?clazz COUNT(DISTINCT ?instance) as ?count\n    WHERE {\n      ?instance <${memberKey}> ?clazz .\n    }\n    GROUP BY ?clazz\n    ORDER BY ?clazz\n    ${limit} ${offset}\n  }\n  OPTIONAL {\n    VALUES ?key { <${attributeKeys.join('> <')}> }\n    ?clazz ?key ?label\n  }\n}\nORDER BY ?clazz`).find());
      items = {};
      for (i = j = 0, ref = res.clazz.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        clazz = res.clazz[i].id();
        clazzGraph = res.clazz[i].getGraph();
        count = res.count[i].value;
        key = (ref1 = res.key[i]) != null ? ref1.id() : void 0;
        label = (ref2 = res.label[i]) != null ? ref2.value : void 0;
        if (items[`${clazz}@${clazzGraph}`] == null) {
          items[`${clazz}@${clazzGraph}`] = {
            uid: clazz,
            graph: clazzGraph || 'null', // todo: this null string value is silly
            labels: key != null ? {
              [key]: label
            } : {},
            count
          };
        } else if (key != null) {
          items[`${clazz}@${clazzGraph}`].labels[key] = label;
        }
      }
      results1 = [];
      for (clazz in items) {
        item = items[clazz];
        results1.push(WeaverMetaQueries._applyPreferredLabel(item, attributeKeys));
      }
      return results1;
    }

    // parameters:
    //   limit
    //   offset
    static async types(attributeKeys, memberKeys, parameters = {}) {
      var clazz, clazzGraph, i, item, items, j, key, label, limit, offset, ref, ref1, ref2, res, results1;
      if (attributeKeys.length < 1) {
        throw new Error('Please specify at least one item in attributeKeys');
      }
      limit = parameters.limit != null ? `LIMIT ${parameters.limit}` : "";
      offset = parameters.offset != null ? `OFFSET ${parameters.offset}` : "";
      res = (await new Weaver.Sparql(`SELECT DISTINCT ?clazz ?key ?label\nWHERE {\n  VALUES ?memberKey { <${memberKeys.join('> <')}> }\n  ?instance ?memberKey ?clazz .\n  OPTIONAL {\n    VALUES ?key { <${attributeKeys.join('> <')}> }\n    ?clazz ?key ?label\n  }\n}\nORDER BY ?clazz\n${limit} ${offset}`).find());
      items = {};
      for (i = j = 0, ref = res.clazz.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        clazz = res.clazz[i].id();
        clazzGraph = res.clazz[i].getGraph();
        key = (ref1 = res.key[i]) != null ? ref1.id() : void 0;
        label = (ref2 = res.label[i]) != null ? ref2.value : void 0;
        if (items[`${clazz}@${clazzGraph}`] == null) {
          items[`${clazz}@${clazzGraph}`] = {
            uid: clazz,
            graph: clazzGraph,
            labels: key != null ? {
              [key]: label
            } : {}
          };
        } else if (key != null) {
          items[`${clazz}@${clazzGraph}`].labels[key] = label;
        }
      }
      results1 = [];
      for (clazz in items) {
        item = items[clazz];
        results1.push(WeaverMetaQueries._applyPreferredLabel(item, attributeKeys));
      }
      return results1;
    }

    // This returns the count for a specific class
    static async typesAndCountForId(id, attributeKeys, memberKey, parameters = {}) {
      var count, i, item, items, j, key, label, node, nodeGraph, ref, ref1, ref2, res, results1;
      if (attributeKeys.length < 1) {
        throw new Error('Please specify at least one item in attributeKeys');
      }
      res = (await new Weaver.Sparql(`SELECT DISTINCT ?node ?count ?key ?label\nWHERE {\n  {\n    SELECT ?node COUNT(DISTINCT ?i) as ?count\n    WHERE {\n      VALUES ?node { <${id}> }\n      ?i <${memberKey}> ?node .\n    }\n    GROUP BY ?node\n    ORDER BY ?node\n  }\n  OPTIONAL {\n    VALUES ?key { <${attributeKeys.join('> <')}> }\n    ?node ?key ?label\n  }\n}\nORDER BY ?node`).find());
      items = {};
      for (i = j = 0, ref = res.node.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        node = res.node[i].id();
        nodeGraph = res.node[i].getGraph();
        count = res.count[i].value;
        key = (ref1 = res.key[i]) != null ? ref1.id() : void 0;
        label = (ref2 = res.label[i]) != null ? ref2.value : void 0;
        if (items[`${node}@${nodeGraph}`] == null) {
          items[`${node}@${nodeGraph}`] = {
            uid: node,
            graph: nodeGraph || 'null', // todo: this null string value is silly
            labels: key != null ? {
              [key]: label
            } : {},
            count
          };
        } else if (key != null) {
          items[`${node}@${nodeGraph}`].labels[key] = label;
        }
      }
      results1 = [];
      for (node in items) {
        item = items[node];
        results1.push(WeaverMetaQueries._applyPreferredLabel(item, attributeKeys));
      }
      return results1;
    }

    // parameters:
    //   limit
    //   offset
    static async relationsAndCount(memberKey, parameters = {}) {
      var count, i, items, j, label, limit, offset, ref, res, source, target;
      limit = parameters.limit != null ? `LIMIT ${parameters.limit}` : "";
      offset = parameters.offset != null ? `OFFSET ${parameters.offset}` : "";
      res = (await new Weaver.Sparql(`SELECT DISTINCT ?source ?target ?label COUNT(?s) as ?count\nWHERE {\n  ?s <${memberKey}> ?source .\n  ?t <${memberKey}> ?target .\n  ?s ?label ?t .\n  FILTER(isIRI(?source))\n  FILTER(isIRI(?target))\n}\nGROUP BY ?source ?target ?label\nORDER BY ?source ?target ?label\n${limit} ${offset}`).find());
      items = [];
      for (i = j = 0, ref = res.source.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        source = res.source[i].id();
        target = res.target[i].id();
        label = res.label[i].id();
        count = res.count[i].value;
        items.push({
          source,
          target,
          sourceGraph: 'null',
          targetGraph: 'null',
          label,
          count
        });
      }
      return items;
    }

    // parameters:
    //   graph
    //   limit
    //   offset
    static async attributesAndDistinctCount(id, memberKey, parameters = {}) {
      var count, i, items, j, label, limit, offset, ref, res;
      limit = parameters.limit != null ? `LIMIT ${parameters.limit}` : "";
      offset = parameters.offset != null ? `OFFSET ${parameters.offset}` : "";
      res = (await new Weaver.Sparql(`SELECT DISTINCT ?label COUNT(?s) as ?count\n${(await graphSelection(parameters))}\nWHERE {\n  ?s <${memberKey}> <${id}> .\n  ?s ?label ?o .\n  FILTER(isLiteral(?o))\n}\nGROUP BY ?label\nORDER BY ?label\n${limit} ${offset}`).find());
      items = [];
      for (i = j = 0, ref = res.label.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        label = res.label[i].id();
        count = res.count[i].value;
        items.push({
          label,
          totalCount: count,
          distinctCount: count
        });
      }
      return items;
    }

    // parameters:
    //   graph
    //   limit
    //   offset
    static async attributesAndCount(id, attributeKey, memberKey, parameters = {}) {
      var count, fullCount, i, item, items, j, l, len, limit, offset, ref, res, value;
      limit = parameters.limit != null ? `LIMIT ${parameters.limit}` : "";
      offset = parameters.offset != null ? `OFFSET ${parameters.offset}` : "";
      res = (await new Weaver.Sparql(`SELECT DISTINCT COUNT(?s) as ?count ?value\n${(await graphSelection(parameters))}\nWHERE {\n  ?s <${memberKey}> <${id}> .\n  ?s <${attributeKey}> ?value .\n  FILTER(isLiteral(?value))\n}\nGROUP BY ?value\n${limit} ${offset}`).find());
      items = [];
      fullCount = 0;
      for (i = j = 0, ref = res.count.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        count = res.count[i].value;
        value = res.value[i].value;
        fullCount += count;
        items.push({
          amount: count,
          value: value
        });
      }
      for (l = 0, len = items.length; l < len; l++) {
        item = items[l];
        item.fullCount = fullCount;
      }
      return items;
    }

    // parameters:
    //   limit
    //   offset
    static async attributesCount(parameters = {}) {
      var count, i, items, j, key, limit, offset, ref, res;
      limit = parameters.limit != null ? `LIMIT ${parameters.limit}` : "";
      offset = parameters.offset != null ? `OFFSET ${parameters.offset}` : "";
      res = (await new Weaver.Sparql(`SELECT DISTINCT COUNT(?s) as ?count ?key\n${(await graphSelection({}))}\nWHERE {\n  ?s ?key ?value .\n  FILTER(isLiteral(?value))\n}\nGROUP BY ?key\nORDER BY ?key\n${limit} ${offset}`).find());
      items = [];
      for (i = j = 0, ref = res.count.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        count = res.count[i].value;
        key = res.key[i].id();
        items.push({key, count});
      }
      return items;
    }

    // parameters:
    //   limit
    //   offset
    static async relationsCount(parameters = {}) {
      var count, i, items, j, key, limit, offset, ref, res;
      limit = parameters.limit != null ? `LIMIT ${parameters.limit}` : "";
      offset = parameters.offset != null ? `OFFSET ${parameters.offset}` : "";
      res = (await new Weaver.Sparql(`SELECT DISTINCT COUNT(?s) as ?count ?key\n${(await graphSelection({}))}\nWHERE {\n  ?s ?key ?value .\n  FILTER(isIRI(?value))\n}\nGROUP BY ?key\nORDER BY ?key\n${limit} ${offset}`).find());
      items = [];
      for (i = j = 0, ref = res.count.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        count = res.count[i].value;
        key = res.key[i].id();
        items.push({key, count});
      }
      return items;
    }

    // parameters:
    //   limit
    //   offset
    static async attributeKeysForNodes(nodes, parameters = {}) {
      var i, ids, items, j, key, limit, n, offset, ref, res;
      limit = parameters.limit != null ? `LIMIT ${parameters.limit}` : "";
      offset = parameters.offset != null ? `OFFSET ${parameters.offset}` : "";
      ids = (function() {
        var j, len, results1;
        results1 = [];
        for (j = 0, len = nodes.length; j < len; j++) {
          n = nodes[j];
          results1.push(n.id());
        }
        return results1;
      })();
      res = (await new Weaver.Sparql(`SELECT DISTINCT ?key\nWHERE {\n  \n  VALUES ?id { <${ids.join('> <')}> }\n  ?id ?key ?value .\n  FILTER(isLiteral(?value))\n}\nORDER BY ?key\n${limit} ${offset}`).find());
      items = [];
      for (i = j = 0, ref = res.key.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        key = res.key[i].id();
        items.push(key);
      }
      return items;
    }

    static async attributeMinMax(attributeKey, nodes) {
      var i, ids, j, max, min, n, ref, res;
      ids = (function() {
        var j, len, results1;
        results1 = [];
        for (j = 0, len = nodes.length; j < len; j++) {
          n = nodes[j];
          results1.push(n.id());
        }
        return results1;
      })();
      res = (await new Weaver.Sparql(`SELECT DISTINCT MIN(?value) as ?min MAX(?value) as ?max\nWHERE { \n  VALUES ?id { <${ids.join('> <')}> }\n  ?id <${attributeKey}> ?value .\n  FILTER(isLiteral(?value))\n}`).find());
      for (i = j = 0, ref = res.min.length; (0 <= ref ? j < ref : j > ref); i = 0 <= ref ? ++j : --j) {
        min = res.min[i].value;
        max = res.max[i].value;
        return {attributeKey, min, max};
      }
      return {};
    }

  };

  module.exports = WeaverMetaQueries;

}).call(this);
